import { initReactI18next } from "react-i18next";

import { LanguageType, messagesDe } from "@shared";
import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";

export const defaultNS = "translation";

export const resources = {
  [LanguageType.de]: {
    translation: messagesDe,
  },
} as const;

// Initialize with the single shared catalog (@shared/src/i18n) — one place for all strings, one
// namespace for app and shared code alike.
void i18next
  // detect user language
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: LanguageType.de,
    supportedLngs: [LanguageType.de],
    ns: [defaultNS],
    defaultNS,
    resources,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

export default i18next;
